export default "__VITE_ASSET__e3592ac3__"